import { Outlet } from "react-router-dom"

export default function ChallengePage() {
  return (
    <section className="z-5 absolute left-0 top-0 flex min-h-screen w-full flex-col gap-4 lg:flex-row lg:gap-8">
      <Outlet />
    </section>
  )
}
